import React from 'react';
import { twJoin } from 'tailwind-merge';

interface FieldLabelProps {
  name: string;
  className?: string;
  label: React.ReactNode;
  isRequired?: boolean;
}

const FieldLabel: React.FC<FieldLabelProps> = ({
  name,
  className,
  label,
  isRequired,
}) => {
  return (
    <label
      htmlFor={name}
      className={twJoin(
        'items-baseline text-neutral-800 font-semibold',
        label && 'min-h-[24px]',
        className,
      )}
    >
      {label}
      <span
        className={twJoin(
          'text-alert-negative hidden',
          isRequired && '!inline',
        )}
      >
        *
      </span>
    </label>
  );
};

export default FieldLabel;
